import { auth } from '../firebase';
import axios from "axios";
import moment from 'moment';

// export const FILE_API_ENDPOINT = "https://dev.iggietech.in/rewards/";
// export const FILE_API_ENDPOINT = "http://localhost:4123/rewards/";
export const FILE_API_ENDPOINT = "https://aaladi.inzpire.in/rewards/";

export const API_ENDPOINT = `${FILE_API_ENDPOINT}`;

export const getAxiosInstance = () => {
    var axiosInstance = axios.create({
        timeout: 1000 * 60
    });
    axiosInstance.defaults.baseURL = API_ENDPOINT;
    return axiosInstance;
};

var axiosInstance = getAxiosInstance();
axiosInstance.interceptors.request.use(
    async function (config) {
        console.log(config.url);
        if (config.url === "users/login") {
            return config;
        } else {

            const user = auth.currentUser; // current signed-in user
            if (user) {
                // forceRefresh = true if you want a fresh token
                const idToken = await user.getIdToken(true);
                console.log("Checking", idToken);
                console.log(idToken);
                config.headers["token"] = `${idToken}`;
            } else {
                // throw new Error('No user is logged in');
            }
        }
        return config;
    },
    function (error) {
        console.log(error);
        return Promise.reject(error);
    }
);


export const createRazorPayOrder = (details) => {
    return axiosInstance.post(`Coupons/getOrderDetails`, details);
}

export const verifyPayment = (details) => {
    return axiosInstance.post(`Coupons/verify-payment`, details);
}

export const getCoupons = () => {
    return axiosInstance.post(`Coupons/getCoupons`, {});
}

export const getOutlets = () => {
    return axiosInstance.get(`Coupons/getOutlets`, {});
}